import type { FaireProductEntity } from "../../entity_types/product";

export const p_pfe2ab3s3n: FaireProductEntity = {
  token: "p_pfe2ab3s3n",
  type: "product",
  name: "Evil Eye Charm 18K Gold Plated SS Double-layer Necklace -FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/b073bfeab37c4a6872152ee344eb6de39cee5fd7ef082cc5b78b05c6e32fc412.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/75f5e7cef1ecdbdffeda93dffd8d60811174315ae7266751806c95e492938d81.jpeg",
    "https://cdn.faire.com/fastly/13981be288be3a4283b95252819578549b2e402067ec3a618e7b754243969cec.jpeg",
    "https://cdn.faire.com/fastly/769dc78f4c407c18a4fd4c9b106dc6a51f4b4903c52bce15954724640a2c7c23.jpeg",
  ],
  priceDollars: 9.85,
  description:
    "Type: Pendant necklace\nMaterial: Stainless steel ，Glass，Cubic zirconia，18K gold plated\nSize of pendant : 32mm*30mm\nLength of chain : 450mm+50mm\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts ",
  tags: [],
  msrpDollars: 24.62,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:28.072Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
